import React from 'react';
import Modal from 'react-modal';
import classNames from 'classnames';
import { networks } from '../../consts';
import styles from '../../boardOne/BragifyEmbed.module.css';
import ModalControls from './ModalControls';
import EmbedModalContent from './EmbedModalContent';
import DefaultModalContent from './DefaultModalContent';

const ModalEmbed = ({
  posts,
  selectedPost,
  boardId,
  showPostMedia,
  formatDistanceLocale,
  closeModal,
  options,
  modalIsOpen,
  itemCount,
  onNavigate,
  config,
  modalRepeat,
  embedType,
  referredPost,
}) => {
  const item = referredPost || posts[selectedPost] || {};
  const { customLink = {} } = item;
  const shareURL = `${
    process.env.REACT_APP_SOCIAL_API_URL || process.env.REACT_APP_CORE_API_URL
  }/board/${config.accountId}/pages/${item.id}?folderId=${config.folderId}`;
  const modalClasses = classNames(styles['bragify-modal'], styles[item.service], {
    [styles['text-only']]: !showPostMedia(item),
  });
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel="Post Details"
      className={modalClasses}
      overlayClassName={styles['bragify-modal-overlay']}
    >
      {modalIsOpen && (
        <ModalControls
          currentItem={selectedPost}
          itemCount={itemCount}
          onNavigate={onNavigate}
          posts={posts}
          modalRepeat={modalRepeat}
          embedType={embedType}
        />
      )}
      {item.service === networks.TIK_TOK ? (
        <EmbedModalContent
          item={item}
          formatDistanceLocale={formatDistanceLocale}
          customLink={customLink}
          shareURL={shareURL}
          closeModal={closeModal}
          options={options}
          index={selectedPost}
          embedType={embedType}
        />
      ) : (
        <DefaultModalContent
          item={item}
          index={selectedPost}
          boardId={boardId}
          showPostMedia={showPostMedia}
          formatDistanceLocale={formatDistanceLocale}
          customLink={customLink}
          shareURL={shareURL}
          closeModal={closeModal}
          options={options}
          embedType={embedType}
        />
      )}
    </Modal>
  );
};

export default ModalEmbed;
